'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/chart-fbc-usage-tooltip-template.html'));
var ChartFBCUsagePartController = function ChartFBCUsagePartController($scope) {
  var DATA_LIMIT = 5;
  function getLimitedData(data) {
    return !$scope.isChartExpanded() ? _.slice(data, 0, DATA_LIMIT) : data;
  }
  $scope.isExpandAvailable = function (chartData) {
    return chartData.data && chartData.data.length > DATA_LIMIT;
  };
  $scope.isChartExpanded = function () {
    return !!$scope.expandMap[$scope.chartData.className];
  };
  $scope.refreshData = function () {
    $scope.showExpandButton = $scope.isExpandAvailable($scope.chartData);
    $scope.reloadChart();
  };
  $scope.reloadChart = function () {
    var dataForChart = getLimitedData($scope.chartData.data);
    $scope.renderChart(dataForChart);
  };
  $scope.toggleItemsLimit = function () {
    $scope.expandMap[$scope.chartData.className] = !$scope.expandMap[$scope.chartData.className];
    $scope.reloadChart();
  };
  $scope.getButtonClass = function () {
    return $scope.isChartExpanded() ? 'fa-compress' : 'fa-expand';
  };
  $scope.createTooltipFormatter = function () {
    var tooltipFormatter = function tooltipFormatter(d) {
      var tooltipData = d.tooltipData;
      var cssClass = '';
      if (tooltipData.length > 5) {
        cssClass = 'fares-chart-tooltip-legend-columns';
      }
      return tooltipTemplate({
        cssClass: cssClass,
        code: d.code,
        isInactive: d.isInactive,
        tooltipData: tooltipData
      });
    };
    tooltipFormatter.cssClass = 'fares-fbc-usage-tooltip';
    return tooltipFormatter;
  };
  $scope.$watch('chartData', $scope.refreshData, true);
};
ChartFBCUsagePartController.$inject = ['$scope'];
module.exports = ChartFBCUsagePartController;